import { render, staticRenderFns } from "./chengBenAging.vue?vue&type=template&id=654e4e6d&scoped=true&"
import script from "./chengBenAging.vue?vue&type=script&lang=js&"
export * from "./chengBenAging.vue?vue&type=script&lang=js&"
import style0 from "./chengBenAging.vue?vue&type=style&index=0&id=654e4e6d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e4e6d",
  null
  
)

export default component.exports